export default {
    routerName: '参数配置',
    table: {
        id: 'ID',
        typeName: '类型',
        typeImage: '图片',
        typeContent: '内容',
        name: '参数名',
        key1: '参数KEY1',
        value1: '参数值1',
        key2: '参数KEY2',
        value2: '参数值2',
        key3: '参数KEY3',
        value3: '参数值3',
        key4: '参数KEY4',
        value4: '参数值4',
        key5: '参数KEY5',
        value5: '参数值5',
        key6: '参数KEY6',
        value6: '参数值6',
        key7: '参数KEY7',
        value7: '参数值7',
        key8: '参数KEY8',
        value8: '参数值8',
        key9: '参数KEY9',
        value9: '参数值9',
        key10: '参数KEY10',
        value10: '参数值10',
    },
};
